export function postMessage(event, data) {
  if (window && window.parent) {
    window.parent.postMessage({ message: { event, data } }, '*')
  }
}
